import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.extendSession = false;

window.axios.interceptors.response.use(
    function(response) {
        if (response.status === 200) {
            window.extendSession = true;
        }

        return response;
    },
    function(error) {
        const domain = window.location.hostname;
        // Platform doesn't provide hostname by default
        let parsed = window.location.hostname;

        try {
            parsed = new URL(error.response.config.url).hostname;
        } catch (e) {
        }
        
        if (domain === parsed && error.response && error.response.status === 401) {
            location.reload();
        }

        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
